export default {
    celular: '(##) #####-####',
    cpf: '###.###.###-##',
    telefone: '(##) ####-####',
}